import { render } from "./Navgator.vue?vue&type=template&id=0e5b253c"
import script from "./Navgator.vue?vue&type=script&lang=js"
export * from "./Navgator.vue?vue&type=script&lang=js"

import exportComponent from "D:\\DealDesk\\Homologação\\Mult_Cliente\\front_mult_clint\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__